export default __webpack_public_path__ + "static/media/chinese-food.6679390b.svg";